import React, { Fragment, useEffect } from "react";
import {
  useExpanded,
  useSortBy,
  useTable,
  useGlobalFilter,
  usePagination,
} from "react-table";
import styles from "../Assets/styles/Assets.module.css";
import downArrow from "../down.svg";
import upArrow from "../up.svg";
import upDownArrow from "../updownarrow.svg";
import TableFooter from "../TableFooter/TableFooter";
import { useState } from "react";
import TableContent from "./referalTableContent";

import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import Info from "../Info/info";
import { UserData } from "../../../Context/DataContext";
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
export function ReferralTable({
  columns,
  data,
  filter,
  setFilter,
  customerStyle,
  component,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
    prepareRow,
    setGlobalFilter,
    pageOptions,
    state,
    rows,
  } = useTable(
    { columns, data, autoResetExpanded: false },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination
  );
  const { height, width } = useWindowDimensions();

  const { pageIndex, pageSize } = state;
  useEffect(() => {
    setGlobalFilter(filter);
  }, [setGlobalFilter, filter]);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.ReferralTable
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.ReferralTable);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  return (
    <>
      {/* <TableFilter filter={globalFilter} setFilter={setGlobalFilter}/> */}
      {/* <TableFilter/> */}
      <div className={styles.referral_table_wrapper}>
        <table {...getTableProps()} className={styles.sub_table_div}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr
                style={
                  width > 980
                    ? {
                        height: "70px",
                      }
                    : {}
                }
                key={i}
                className={styles.head_row}
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column, i) => {
                  return (
                    <th
                      style={{
                        width: "100%",
                      }}
                      key={i}
                      className={styles[`th_${column.id.replace(" ", "")}`]}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div className={styles.headerWrapper}>
                        <p className={styles.column_title}>
                          {column.render("Header")}
                        </p>
                        <div
                          className={
                            column.canSort ? styles.referral_sort_icon : ""
                          }
                          style={
                            column.canSort
                              ? {
                                  background: `url(${
                                    column.canSort
                                      ? column.isSorted
                                        ? column.isSortedDesc
                                          ? downArrow
                                          : upArrow
                                        : upDownArrow
                                      : null
                                  }) no-repeat center`,
                                }
                              : {}
                          }
                        />
                        {column.id !== "reward" &&
                          component !== "beneficiary" && (
                            <Info
                              message={content[`referral_table_${column?.id}`]}
                            />
                          )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                const colIndex = i + 1 + pageIndex * pageSize;

                return (
                  // <React.Fragment key={...row.getRowProps().key}>
                  <React.Fragment key={row.getRowProps().key}>
                    <tr
                      onClick={(e) => {
                        if (
                          e.target.innerText === "Resend" ||
                          e.target.innerText === "Renvoyer"
                        )
                          return;
                        if (width < 980) {
                          row.toggleRowExpanded();
                        }
                      }}
                      className={
                        customerStyle === "customer"
                          ? styles.customerRow
                          : styles.row
                      }
                      style={
                        row.isExpanded && width < 980
                          ? {
                              backgroundColor: "rgba(0, 145, 234, 0.07)",
                              fontSize: "12px",
                              height: "60px",
                            }
                          : { fontSize: "12px", height: "60px" }
                      }
                    >
                      {/* {row.cells.map((cell, i) => {
                        if (cell.column.Header !== "Date") return null;

                        return (
                          <TableContent
                            row={row}
                            cell={cell}
                            key={i}
                            canResend={row.original.can_resend}
                            id={row.original.id}
                            rowNumber={colIndex}
                          />
                        );
                      })} */}

                      {row.cells.map((cell, i) => {
                        return (
                          <Fragment key={i}>
                            <TableContent
                              row={row}
                              cell={cell}
                              key={i}
                              canResend={row.original.can_resend}
                              id={row.original.id}
                              rowNumber={colIndex}
                              code={row.original.code}
                            />
                          </Fragment>
                        );
                      })}
                    </tr>
                    {/* <tr className={styles.row}>
                      {row.cells.map((cell, i) => {
                        console.log(cell);
                        return (
                          <TableContent
                            row={row}
                            cell={cell}
                            key={i}
                            canResend={row.original.can_resend}
                            id={row.original.id}
                            rowNumber={colIndex}
                          />
                        );
                      })}
                    </tr> */}
                    {row.isExpanded && width < 980 ? (
                      <div
                        onClick={() => console.log(row)}
                        className={styles.expandedContainer}
                      >
                        <p
                          style={{
                            paddingLeft: "35px",
                            fontWeight: 500,
                          }}
                        >
                          Reward
                        </p>
                        <p
                          style={{
                            paddingLeft: "15px",
                          }}
                        >
                          {row.original.reward}
                        </p>
                        <p
                          style={{
                            paddingLeft: "35px",
                            fontWeight: 500,
                          }}
                        >
                          Reward Status
                        </p>
                        <p
                          style={{
                            paddingLeft: "15px",
                          }}
                        >
                          {row.original.reward_status}
                        </p>
                        <p
                          style={{
                            paddingLeft: "35px",
                            fontWeight: 500,
                          }}
                        >
                          Referral Code
                        </p>
                        <p
                          style={{
                            paddingLeft: "15px",
                          }}
                        >
                          {row.original.code}
                        </p>
                        <p
                          style={{
                            paddingLeft: "35px",
                            fontWeight: 500,
                          }}
                        >
                          Referral Method
                        </p>
                        <p
                          style={{
                            paddingLeft: "15px",
                          }}
                        >
                          {row.original.method === "code" ? (
                            <span>Coupon Code</span>
                          ) : row.original.method === "email" ? (
                            <span>Invited via Email</span>
                          ) : row.original.method === "link" ? (
                            <span>Direct link</span>
                          ) : null}
                        </p>
                      </div>
                    ) : null}
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
        {page.length > 0 && (
          <TableFooter
            setPageSize={setPageSize}
            pageSize={pageSize}
            maxPage={pageOptions.length}
            pageIndex={pageIndex}
            previousPage={previousPage}
            nextPage={nextPage}
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            component={"referral"}
          ></TableFooter>
        )}
        {page.length === 0 && rows.length === 0 && (
          <div
            style={{
              marginBottom: "50px",
            }}
            className={styles.referralNoResults}
          >
            <p>{content.referralTableText1}</p>
          </div>
        )}
      </div>
    </>
  );
}
